var map = {
	"./components/ib-payments/cmpnts/ib-pmt-confirmation/assets/ib-pmt-order-confirmation-view.html": 88058,
	"node_modules/ib-web-payments/dist/components/ib-payments/cmpnts/ib-pmt-confirmation/assets/ib-pmt-order-confirmation-view.html": 88058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57855;